import { useRef } from "react"
import './OracleLkmExperts.css'
import HangingMenus from './components/HangingMenus';
import ExpertModal from './components/experts/ExpertModal';
import { expertsData } from '../data/Oracle/expert.js';

const OracleLkmExperts = () => {        
    const childCompRef = useRef();
    return (        
        <>
            <div className="oracle-expert-banner">
                <img src={process.env.PUBLIC_URL + "/images/Oracle/expert/banner.png"} alt="Expert Banner" />
            </div>
            <div className="oracle-expert-content">
                <p>
                Meet the minds behind ATCI’s intensive, innovative, fit-for-market Oracle learning programs, enabling Accenture to lead in the marketplace and deliver on the promise of client excellence.
                </p>
            </div>
            <div className="oracle-lead-expert-cards">                
                {expertsData.map((expert) => {
                                        
                    return <>
                        {(expert.ename === 'praveen_rajaram' || 
                         expert.ename === 'madhuri_gattu' ||
                         expert.ename === 'raji_raghunath') &&
                         <img src={process.env.PUBLIC_URL + `/images/Oracle/expert/${expert.ename}.png`} alt="Oracle Expert" className="oracle__expert" onClick={() => childCompRef.current.handleOpen(expert.ename)} />}
                    </>
                })}                                
            </div>
            <div className="oracle-expert-cards">                
                {expertsData.map((expert) => {
                                        
                    return <>
                        {expert.ename !== 'praveen_rajaram' && 
                         expert.ename !== 'madhuri_gattu' &&
                         expert.ename !== 'raji_raghunath' &&
                         <img src={process.env.PUBLIC_URL + `/images/Oracle/expert/${expert.ename}.png`} alt="Oracle Expert" className="oracle__expert" onClick={() => childCompRef.current.handleOpen(expert.ename)} />}
                    </>
                })}                                
            </div>
            <ExpertModal ref={childCompRef}/>
            <HangingMenus />
        </>        
    );
};

export default OracleLkmExperts